module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cp_stills_pet_500_pwd_mountain_b.1c746283.png";